import React from 'react';
import { useTranslation } from 'react-i18next';
import { DOUGHNUT_CHART_COLORS } from '../../utils/const';
import CardSelectorAndEvaluationDialogContainer from './CardSelectorAndEvaluationDialogContainer';

const AverageOfRatesOfObjective = ({ averageOfObjectiveRates }) => {
  const { t } = useTranslation();

  return (
    <CardSelectorAndEvaluationDialogContainer
      rate = { {
        value: isNaN(averageOfObjectiveRates) ? undefined : averageOfObjectiveRates,
        criteria: {
          criteria_name: { hu: t('objective.average.title') }
        }
      } }
      rateable = { false }
      doughnutChartColor = { DOUGHNUT_CHART_COLORS.GREEN }
    />
  );
};

export default AverageOfRatesOfObjective;
